module.exports = __webpack_public_path__ + "static/media/group_gifting.3bd91175.svg";